(function () {
    const displayModal = document.currentScript.getAttribute('data-display-modal');

    if (displayModal == "false") {
        return;
    }

    var modal = document.querySelector("#hd-StoreSelector_Modal");
    var btn = document.querySelector(".navigation__language");
    var span = document.querySelector("#hd-StoreSelector_Modal-close");

    if (btn) {
        btn.onclick = function() {
            modal.style.display = "block";
            modal.style.width = "100%";
            modal.style.height = "100%";
            modal.style.contentVisibility = "auto";
        }
        span.onclick = function() {
            modal.style.display = "none";
            modal.style.width = "0";
            modal.style.height = "0";
            modal.style.contentVisibility = "hidden";
        }
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
                modal.style.width = "0";
                modal.style.height = "0";
                modal.style.contentVisibility = "hidden";
            }
        }
    }

    var modal = document.getElementById("hd-StoreSelector_Modal");
    var btn = document.getElementById("mbm-StoreSelector_Btn");
    var span = document.getElementById("hd-StoreSelector_Modal-close");

    if (btn) {
        btn.onclick = function() {
            modal.style.display = "block";
            modal.style.width = "100%";
            modal.style.height = "100%";
            modal.style.contentVisibility = "auto";
        }
        span.onclick = function() {
            modal.style.display = "none";
            modal.style.width = "0";
            modal.style.height = "0";
            modal.style.contentVisibility = "hidden";
        }
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
                modal.style.width = "0";
                modal.style.height = "0";
                modal.style.contentVisibility = "hidden";
            }
        }
    }

    var modal = document.getElementById("hd-StoreSelector_Modal");
    var btn = document.getElementById("ft-StoreSelector_Btn");
    var span = document.getElementById("hd-StoreSelector_Modal-close");

    if (btn) {
        btn.onclick = function() {
            modal.style.display = "block";
            modal.style.width = "100%";
            modal.style.height = "100%";
            modal.style.contentVisibility = "auto";
        }
        span.onclick = function() {
            modal.style.display = "none";
            modal.style.width = "0";
            modal.style.height = "0";
            modal.style.contentVisibility = "hidden";
        }
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
                modal.style.width = "0";
                modal.style.height = "0";
                modal.style.contentVisibility = "hidden";
            }
        }
    }
})();